// SPECULATIVE SHAPE — the tel_vm_list RESPONSE is NOT defined in the contract
// (docs/StationBridge-Telephony-Contract.md only fixes the command params, not the result
// payload). This interface is the UI's proposed shape; the backend session must confirm it
// and add it to the contract. The transport returns it inside CommandResponse.result.messages.
export interface VmMessage {
  message_id: string
  from_name: string
  from_number: string
  received_at: string // ISO8601
  duration_seconds: number
  folder: 'new' | 'old'
}

const iso = (minsAgo: number) => new Date(Date.now() - minsAgo * 60_000).toISOString()

// Mock voicemail messages for a mailbox (demo only; replaced by the live vm_list payload).
export function mockVoicemails(mailbox: string): VmMessage[] {
  return [
    { message_id: `${mailbox}-1`, from_name: 'A. Customer', from_number: '+14805550199', received_at: iso(22), duration_seconds: 47, folder: 'new' },
    { message_id: `${mailbox}-2`, from_name: '', from_number: '+18005551234', received_at: iso(95), duration_seconds: 18, folder: 'new' },
    { message_id: `${mailbox}-3`, from_name: 'Dr. Lin', from_number: '+14805550182', received_at: iso(180), duration_seconds: 122, folder: 'new' },
    { message_id: `${mailbox}-4`, from_name: 'Billing', from_number: '1044', received_at: iso(1440), duration_seconds: 64, folder: 'old' },
    { message_id: `${mailbox}-5`, from_name: 'R. Diaz', from_number: '+14805550143', received_at: iso(2880), duration_seconds: 9, folder: 'old' }
  ]
}
